<template lang="html">
    <div class="flex-shrink-0" v-if="latestCard">
        <h3 class="h5 font-weight-bold mb-4">Latest card</h3>
        <div class="d-flex align-items-center">
            <div
                class="single-card shadow mr-4"
                :class="getCardColor(latestCard.suit)"
                :data-value="getCardValue(latestCard.value)"
                :data-suit="getCardSuit(latestCard.suit)"
            ></div>
            <div class="h5 font-weight-bold m-0 d-flex align-items-center">
                {{ rule.title }}
                <button v-b-modal.rule class="btn btn-primary small-btn ml-3">
                    ?
                </button>

                <b-modal id="rule" hide-footer centered>
                    <template v-slot:modal-header="{ close }" class="mb-0">
                        <!-- Emulate built in modal header close button action -->
                        <h5 class="font-weight-bold">
                            {{ rule.title }}
                        </h5>
                        <font-awesome-icon icon="times" @click="close" />
                    </template>
                    <div class="d-flex align-items-center">
                        <div
                            class="single-card shadow mr-4"
                            style="font-size: 30px;"
                            :class="getCardColor(latestCard.suit)"
                            :data-value="getCardValue(latestCard.value)"
                            :data-suit="getCardSuit(latestCard.suit)"
                        ></div>
                        <div>
                            {{ rule.description }}
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import cards from '@/mixins/cards';

export default {
    mixins: [cards],
    data() {
        return {
            rule: {
                title: '',
                description: '',
            },
        };
    },
    computed: {
        latestCard() {
            return this.$store.state.room.latestCard;
        },
    },
    watch: {
        latestCard: {
            handler(val) {
                if (val) {
                    const rule = this.$store.getters.GET_RULE;
                    this.rule = rule || '';
                }
            },
            immediate: true,
        },
    },
};
</script>

<style lang="css"></style>
